import React from 'react';
import { Router } from 'react-router';
import MainSwitch from './main-switch';
import history from '../../utils/history';

const Main: React.FunctionComponent = () => {
  return (
    <Router history={history}>
      <MainSwitch />
    </Router>
  );
};

export default Main;
